import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import App from './App';
import AccountPage from './pages/AccountPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import Legalnotices from './pages/Legalnotices';
import Pricing from './pages/Pricing';
import Features from './pages/Features';

function Router() {
  const [session, setSession] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = () => {
    setUser(null);
    setSession(null);
  };

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Simple client-side routing based on URL path
  const path = window.location.pathname;

  if (path === '/account') {
    return <AccountPage user={user} onSignOut={handleSignOut} />;
  }
  
  if (path === '/privacy-policy') {
    return <PrivacyPolicy />;
  }
  
  if (path === '/terms') {
    return <Terms />;
  }
  
  if (path === '/disclaimer') {
    return <Disclaimer />;
  }
  
  if (path === '/legalnotices') {
    return <Legalnotices />;
  }
 if (path === '/pricing') {
    return <Pricing user={user} />;
 }
if (path === '/features') {
   return <Features />;
}
  // Default to main app
  return <App initialUser={user} initialSession={session} onSignOut={handleSignOut} />;
}

export default Router;
